import React, { useEffect, useState } from "react";
import ProfileComponent from "./components/profile_component";
import { ProfileUpdateContextProvider } from "../profileupdate/context/profile_update_context";
import { useNavigate, useLocation } from "react-router-dom";
import { USER_TOKEN_KEY } from "../../../../core/constants/app_constants";
import { LoginRoute } from "../../../../core/routes/route_constants";
import { localStorageService } from "../../di/di";

export default function ProfilePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showCancelTour, setShowCancelTour] = useState(false);

  useEffect(() => {
    // Check login
    const token = localStorage.getItem(USER_TOKEN_KEY);
    if (!token) {
      // Use a custom --hash-- separator to preserve the hash through login
      const hash = location.hash ? location.hash.substring(1) : ""; // remove the #
      
      let redirectPath = "/dashboard/profile";
      if (hash) {
        redirectPath += `#${hash}`;
        if(hash === 'cancel-subscription'){
          localStorageService.deleteData('cancelTourShown');
        }
      }
      window.location.href = `${LoginRoute}?redirect=${encodeURIComponent(redirectPath)}`;
      return;
    }
    // Show tour if hash is #cancel-subscription
    if (window.location.hash === "#cancel-subscription") {
      setShowCancelTour(true);
    } else {
      setShowCancelTour(false);
    }
    // Listen for hash changes
    const onHashChange = () => {
      if (window.location.hash === "#cancel-subscription") {
        setShowCancelTour(true);
      } else {
        setShowCancelTour(false);
      }
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [navigate, location]);

  return (
    <ProfileUpdateContextProvider>
      <ProfileComponent showCancelTour={showCancelTour} />
    </ProfileUpdateContextProvider>
  );
}
